import { render } from "./DinnerList.vue?vue&type=template&id=45bef731&ts=true"
import script from "./DinnerList.vue?vue&type=script&lang=ts"
export * from "./DinnerList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__